/**
 * Formats a phone number by adding parentheses, space and hyphen ((00) 00000-0000)
 */
export const formatPhone = (value: string) => {
  const numericValue = value.replace(/\D/g, '');
  if (numericValue.length <= 2) return numericValue;
  if (numericValue.length <= 6)
    return `(${numericValue.slice(0, 2)}) ${numericValue.slice(2)}`;
  if (numericValue.length <= 10)
    return `(${numericValue.slice(0, 2)}) ${numericValue.slice(2, 6)}-${numericValue.slice(6)}`;
  return `(${numericValue.slice(0, 2)}) ${numericValue.slice(2, 7)}-${numericValue.slice(7, 11)}`;
};

export const formatCnpj = (value: string): string => {
  const clean = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
  const root = clean.slice(0, 12);
  const check = clean.slice(12, 14).replace(/\D/g, '');
  const chars = root + check;

  const match = chars.match(
    /^([A-Z0-9]{0,2})([A-Z0-9]{0,3})([A-Z0-9]{0,3})([A-Z0-9]{0,4})(\d{0,2})$/
  );

  if (!match) return chars;

  return [
    match[1],
    match[2] && '.' + match[2],
    match[3] && '.' + match[3],
    match[4] && '/' + match[4],
    match[5] && '-' + match[5],
  ]
    .filter(Boolean)
    .join('');
};

export const formatCPF = (value: string): string => {
  const digits = value.replace(/\D/g, '');
  const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})$/);
  if (!match) return digits;
  return [
    match[1],
    match[2] && '.' + match[2],
    match[3] && '.' + match[3],
    match[4] && '-' + match[4],
  ]
    .filter(Boolean)
    .join('');
};

export const formatNumberOf = (value: string): string => {
  const digits = value.match(/\d+/g)?.join('') || '';

  const noLeadingZeros = digits.replace(/^0+/, '');

  return noLeadingZeros || '';
};

export const formatCEP = (value: string): string => {
  const digits = value.replace(/\D/g, '');
  const match = digits.match(/^(\d{0,5})(\d{0,3})$/);

  if (!match) return digits;

  return [match[1], match[2] && '-' + match[2]].filter(Boolean).join('');
};
